import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const expensesStatusListWidget: DashboardWidgetConfiguration = {
  widgetId: "expenses.status-list",
  name: "Claims by status",
  description: "Claims by status as a compact RQL list.",
  apps: [
    "home",
    "expenses",
  ],
  template: "list",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "expenses.records",
      ...period(30),
      select: [
        {
          type: "field",
          field: "state",
          as: "state",
        },
        {
          type: "aggregate",
          function: "count_distinct",
          field: "expense_id",
          as: "claims",
        },
      ],
      group_by: [
        {
          field: "state",
        },
      ],
      order_by: [
        {
          ref: "claims",
          direction: "desc",
        },
      ],
      limit: 8,
    },
  },
  inputs: {
    title: "Claims by status",
    columns: [
      {
        key: "state",
        label: "Status",
      },
      {
        key: "claims",
        label: "Claims",
        align: "end",
        format: "number",
      },
    ],
    maxRows: 8,
    showAccountTypeDescription: false,
  },
  dummyData: {
    rows: [
      {
        state: "Approved",
        claims: 34,
      },
      {
        state: "Submitted",
        claims: 19,
      },
      {
        state: "Draft",
        claims: 11,
      },
    ],
  },
  limits: {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 3,
    maxHeight: 8,
    defaultWidth: 6,
    defaultHeight: 4,
  },
};
